import axios from 'axios';
import * as myConstClass from '../Config/config.js';
import { Encrypt } from '../Helpers/Common'; //Include Home
const END_POINT = myConstClass.BACKEND_ENDPOINT;
const AUTH_TOKEN = myConstClass.AUTH_TOKEN;

const headers = {
  "Access-Control-Allow-Origin": "*",
  'Access-Control-Allow-Credentials': true,
  'x-access-auth-token': '' + AUTH_TOKEN + '',
}

//Get status of content play,pause,forward,backward

export async function Playstatus(type, duration, content_id, Xr) {
  var postData = {
    duration: duration,
    content_id: content_id,
    random_number: Xr,
    type: type,
    msisdn: localStorage.getItem("msisdn")
  }

  return await Encrypt(postData).then(res => {
    const postData = {
      "digest": res
    }
    return axios.post(END_POINT + '/player/playstatus', postData, {
      headers: headers
    }).then(res => {
      const data = res;
      return data;
    });
  })
}

//Get tracking wherver user close the player 

export async function Playtracking(type, duration, content_id, contenttitle) {
  var postData = {
    type: type,
    duration: duration,
    content_id: content_id,
    title: contenttitle,
    msisdn: localStorage.getItem("msisdn")
  }
  return await Encrypt(postData).then(async res => {
    const postData = {
      "digest": res
    }
    const res_2 = await axios.post(END_POINT + '/player/playtracking', postData, {
      headers: headers
    });
    const data = res_2;
    return data;
  })
}



